(() => {
  if (customElements.get('custom-subscribe-widget')) return;

  class CustomSubscribeWidget extends HTMLElement {
    constructor() {
      super();
      this.onOptionChange = this.onOptionChange.bind(this);
      this.onPlanSelectChange = this.onPlanSelectChange.bind(this);
      this.onPlanSelectClick = this.onPlanSelectClick.bind(this);
    }

    connectedCallback() {
      this.form = this.closest('form');
      this.sellingPlanInput = this.form?.querySelector('[data-js-selling-plan-input]');
      this.optionInputs = this.querySelectorAll('[data-js-purchase-option]');
      this.planSelect = this.querySelector('[data-js-selling-plan-select]');
      this.subscriptionOption = this.querySelector('[data-js-subscription-option]');
      this.priceSummary =
        this.closest('[data-js-product-card]')?.querySelector('[data-js-price-summary]') ||
        this.closest('.csw_root')?.querySelector('[data-js-price-summary]');

      if (!this.optionInputs.length) return;

      this.optionInputs.forEach((input) => {
        input.addEventListener('change', this.onOptionChange);
      });

      if (this.planSelect) {
        this.planSelect.addEventListener('change', this.onPlanSelectChange);
        this.planSelect.addEventListener('click', this.onPlanSelectClick);
      }

      this.syncSubscriptionOptionFromSelect();

      const defaultOption = this.dataset.defaultOption || 'subscription';
      const defaultInput =
        this.querySelector(`[data-js-purchase-option][value="${defaultOption}"]`) || this.optionInputs[0];

      if (defaultInput) {
        defaultInput.checked = true;
        this.applyOption(defaultInput);
      }
    }

    disconnectedCallback() {
      this.optionInputs?.forEach((input) => {
        input.removeEventListener('change', this.onOptionChange);
      });

      if (this.planSelect) {
        this.planSelect.removeEventListener('change', this.onPlanSelectChange);
        this.planSelect.removeEventListener('click', this.onPlanSelectClick);
      }
    }

    onPlanSelectClick(event) {
      event.stopPropagation();
    }

    onPlanSelectChange() {
      const subscriptionInput = this.querySelector('[data-js-purchase-option][value="subscription"]');
      if (subscriptionInput && !subscriptionInput.checked) {
        subscriptionInput.checked = true;
      }

      this.syncSubscriptionOptionFromSelect();

      if (subscriptionInput?.checked) {
        this.applyOption(subscriptionInput);
      }
    }

    onOptionChange(event) {
      if (event.target === document.activeElement) {
        event.target.blur();
      }

      this.applyOption(event.target);
    }

    syncSubscriptionOptionFromSelect() {
      if (!this.planSelect || !this.subscriptionOption) return;

      const selectedOption = this.planSelect.selectedOptions[0];
      if (!selectedOption) return;

      const comparePrice = selectedOption.dataset.comparePrice || '';
      const currentPrice = selectedOption.dataset.currentPrice || '';
      const saveLabel = selectedOption.dataset.saveLabel || '';
      const savePercent = selectedOption.dataset.savePercent || '';

      this.subscriptionOption.dataset.sellingPlanId = selectedOption.value;
      this.subscriptionOption.dataset.comparePrice = comparePrice;
      this.subscriptionOption.dataset.currentPrice = currentPrice;
      this.subscriptionOption.dataset.saveLabel = saveLabel;

      const compareEl = this.subscriptionOption.querySelector('[data-js-subscription-compare]');
      const currentEl = this.subscriptionOption.querySelector('[data-js-subscription-current]');
      const titleEl = this.subscriptionOption.querySelector('[data-js-subscription-title]');

      if (compareEl) {
        const compareHidden = !comparePrice;
        if (compareEl.textContent !== comparePrice) {
          compareEl.textContent = comparePrice;
        }
        if (compareEl.hidden !== compareHidden) {
          compareEl.hidden = compareHidden;
        }
      }

      if (currentEl && currentEl.textContent !== currentPrice) {
        currentEl.textContent = currentPrice;
      }

      if (titleEl) {
        const saveTemplate = this.dataset.subscribeSaveTemplate || '';
        const defaultTemplate = this.dataset.subscribeTemplate || titleEl.textContent;
        const nextTitle =
          savePercent && saveTemplate.includes('[percent]')
            ? saveTemplate.replace('[percent]', savePercent)
            : defaultTemplate;

        if (titleEl.textContent !== nextTitle) {
          titleEl.textContent = nextTitle;
        }
      }
    }

    applyOption(input) {
      const option = input.closest('[data-purchase-option]');
      if (!option) return;

      const selectedOption = this.querySelector('[data-purchase-option].is-selected');
      if (selectedOption === option && input.checked) return;

      if (input.value === 'subscription') {
        this.syncSubscriptionOptionFromSelect();
      }

      this.querySelectorAll('[data-purchase-option]').forEach((item) => {
        const isSelected = item === option;
        if (item.classList.contains('is-selected') !== isSelected) {
          item.classList.toggle('is-selected', isSelected);
        }
      });

      const purchaseType = input.value;
      const sellingPlanId = option.dataset.sellingPlanId || '';

      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = purchaseType === 'subscription' ? sellingPlanId : '';
        this.sellingPlanInput.disabled = purchaseType !== 'subscription' || !sellingPlanId;
      }

      this.updatePriceSummary(option);
      this.dispatchEvent(
        new CustomEvent('custom-subscribe-widget:change', {
          bubbles: true,
          detail: {
            purchaseType,
            sellingPlanId,
          },
        })
      );
    }

    updatePriceSummary(option) {
      if (!this.priceSummary) return;

      const compareEl = this.priceSummary.querySelector('[data-js-price-compare]');
      const currentEl = this.priceSummary.querySelector('[data-js-price-current]');
      const saveEl = this.priceSummary.querySelector('[data-js-save-badge]');
      const comparePrice = option.dataset.comparePrice || '';
      const currentPrice = option.dataset.currentPrice || '';
      const saveLabel = option.dataset.saveLabel || '';

      if (compareEl) {
        const compareHidden = !comparePrice;
        if (compareEl.textContent !== comparePrice) {
          compareEl.textContent = comparePrice;
        }
        if (compareEl.hidden !== compareHidden) {
          compareEl.hidden = compareHidden;
        }
      }

      if (currentEl && currentEl.textContent !== currentPrice) {
        currentEl.textContent = currentPrice;
      }

      if (saveEl) {
        const saveHidden = !saveLabel;
        if (saveEl.textContent !== saveLabel) {
          saveEl.textContent = saveLabel;
        }
        if (saveEl.hidden !== saveHidden) {
          saveEl.hidden = saveHidden;
        }
      }
    }
  }

  customElements.define('custom-subscribe-widget', CustomSubscribeWidget);
})();
